import { useEffect, useState, type FormEvent } from 'react';
import { useAuth } from '@/shared/auth/AuthContext';
import { useCenterConfig } from '@/shared/hooks/useCenterConfig';
import { saveCenterConfig } from '@/shared/firebase/admin';

export function MyResidenceTab() {
  const { centerId } = useAuth();
  const cfg = useCenterConfig(centerId);

  const [name, setName] = useState('');
  const [address, setAddress] = useState('');
  const [phone, setPhone] = useState('');
  const [saving, setSaving] = useState(false);
  const [savedAt, setSavedAt] = useState<number | null>(null);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    setName(cfg?.name || '');
    setAddress(cfg?.address || '');
    setPhone(cfg?.phone || '');
  }, [cfg]);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setSaving(true); setErr(null);
    try {
      await saveCenterConfig(centerId, { name, address, phone });
      setSavedAt(Date.now());
    } catch (e) {
      setErr(e instanceof Error ? e.message : String(e));
    } finally { setSaving(false); }
  }

  return (
    <div className="max-w-xl mx-auto space-y-4">
      <div>
        <h2 className="text-xl font-extrabold text-slate-900">Mi residencia</h2>
        <p className="text-sm text-slate-500">
          Datos de la residencia que se muestran en la app a cuidadores y familiares.
        </p>
        <p className="text-xs text-slate-400 mt-1">
          ID: <code>{centerId}</code> (configurado en el despliegue)
        </p>
      </div>

      <form onSubmit={submit} className="card space-y-3">
        <div>
          <label className="label">Nombre</label>
          <input className="input" value={name} onChange={(e) => setName(e.target.value)} placeholder="Residencia Los Olivos" />
        </div>
        <div>
          <label className="label">Dirección</label>
          <input className="input" value={address} onChange={(e) => setAddress(e.target.value)} placeholder="C/ Mayor 12, Madrid" />
        </div>
        <div>
          <label className="label">Teléfono</label>
          <input className="input" value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="+34 900 000 000" />
          <p className="text-xs text-slate-500 mt-1">Lo verán los familiares como botón "Llamar a la residencia".</p>
        </div>

        {err && <div className="rounded-xl bg-danger-50 text-danger px-3 py-2 text-sm">{err}</div>}
        {savedAt && !err && (
          <div className="rounded-xl bg-success-50 text-success px-3 py-2 text-sm">Guardado ✓</div>
        )}

        <button type="submit" disabled={saving} className="btn-primary w-full">
          {saving ? 'Guardando…' : 'Guardar cambios'}
        </button>
      </form>
    </div>
  );
}
